import { useState, useEffect, useCallback } from "react";
import { useSnackbar } from "notistack";

import Form from "../../ui-kits/form/Form";

import { statusesOfForm } from "../../utilities/consts/models";
import { sendConsultingRequest } from "../../services/consultingRequestServices";
import { consultingRequestFormFields } from "../../utilities/consts/formFields";
import { getConsultingRequestPageTitle } from "../../services/pagesRequestServices";

const ConsultingRequest = () => {
  const [statusForm, changeStatusForm] = useState(statusesOfForm.filling);
  const { enqueueSnackbar } = useSnackbar();
  const [pageTitle, changePageTitle] = useState(null);

  const onSubmit = (data) => {
    changeStatusForm(statusesOfForm.sending);
    sendConsultingRequest(data)
      .then(() => {
        enqueueSnackbar("درخواست شما با موفقیت ارسال شد.", {
          variant: "success",
        });
        changeStatusForm(statusesOfForm.success);
      })
      .catch(() =>
        enqueueSnackbar("ارسال درخواست با خطا مواجه شد.", { variant: "error" })
      )
      .finally(() => {
        changeStatusForm(statusesOfForm.filling);
      });
  };

  const getPageTitle = useCallback(() => {
    return getConsultingRequestPageTitle().then((res) => changePageTitle(res));
  }, []);

  useEffect(() => {
    getPageTitle();
  }, [getPageTitle]);

  return (
    <div className="row subpage__container justify-content-center">
      <div className="col-12 col-lg-8 pb-3 px-0 px-md-2">
        <p className="text-14 text-md-18 line-height-2x px-0 mt-3 mt-md-5 text-white">
          {pageTitle?.title}
        </p>
      </div>
      <div className="col-12 col-lg-8 px-0 px-md-2">
        <Form
          fields={consultingRequestFormFields}
          onSubmit={onSubmit}
          isSending={statusForm === statusesOfForm.sending}
          isSuccess={statusForm === statusesOfForm.success}
        />
      </div>
    </div>
  );
};
export default ConsultingRequest;
